<template>
  <div class="user_info_form user_info_form_contact">
    <h4>연락처</h4>
    <p class="description">
      정확한 연락처를 입력해주세요. 정확하지 않을 경우 소득신고가 불가능하여 입금이 불가능할 수 있습니다.
    </p>

    <tel-no-form @update="updateTelNo"></tel-no-form>
    <address-form @update="updateAddress"></address-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TelNoForm from '@/components/modules/common/TelNoForm';
import AddressForm from '@/components/modules/common/AddressForm';

export default {
  components: {
    TelNoForm,
    AddressForm,
  },
  data() {
    return {
      telNo: {},
      address: {},
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
  },
  methods: {
    ...mapActions('userInfo', ['setModifyContact']),
    updateContact() {
      this.$emit('update', {
        request: { ...this.telNo.request, ...this.address.request },
        isState: !!this.telNo.isState && !!this.address.isState,
      });
    },
    updateTelNo(val) {
      this.telNo = val;
      this.updateContact();
    },
    updateAddress(val) {
      this.address = val;
      this.updateContact();
    },
  },
};
</script>
<style lang="scss"></style>
